import { AxiosResponse } from 'axios';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ResponseBase } from 'src/app/models/response-base';
import { CostCenterResponse } from '../../models/cost-center/cost-center-response.model';
import { DepartmentResponse } from '../../models/department/department-response.model';
import { UnitResponse } from '../../models/unit/unit-response.model';
import { api } from '../../services/api';
import { COST_CENTER_LIST, DEPARTMENT_LIST, UNIT_LIST } from '../contants';
import { getCostCentersError, getCostCentersSuccess, getDepartmentsError, getDepartmentsSuccess, getUnitsError, getUnitsSuccess } from './actions';

type fetchCostCenterPayload = { assignorGuid: string }
type fetchCostCenterParams = { payload: fetchCostCenterPayload, type: string };

type fetchUnitPayload = { assignorGuid: string }
type fetchUnitParams = { payload: fetchUnitPayload, type: string };

type fetchDepartmentPayload = { assignorGuid: string }
type fetchDepartmentParams = { payload: fetchDepartmentPayload, type: string };

export function* watchFetchCostCenters() {
    yield takeEvery(COST_CENTER_LIST, fetchCostCenters);
}
  
const fetchCostCentersAsync = async (assignorGuid: string) =>
    await api.get(`assignorOrganization/assignors/${assignorGuid}`)
        .then((response: any) => response)
        .catch((error: any) => error);


function* fetchCostCenters({ payload }: fetchCostCenterParams) {
    try {
        const { assignorGuid } = payload;
        
        const response: AxiosResponse<ResponseBase<CostCenterResponse[]>> = yield call(fetchCostCentersAsync, assignorGuid);

        if (response?.data?.status == 1) {
        yield put(getCostCentersSuccess(response?.data?.result));
        } else {
        yield put(getCostCentersError(response?.data?.message));
        }
    } catch (error) {
        yield put(getCostCentersError(error));
    }
}

export function* watchFetchUnits() {
    yield takeEvery(UNIT_LIST, fetchUnits);
}
  
const fetchUnitsAsync = async (assignorGuid: string) =>
    await api.get(`assignorOrganization/unit/${assignorGuid}`)
        .then((response: any) => response)
        .catch((error: any) => error);


function* fetchUnits({ payload }: fetchUnitParams) {
    try {
        const { assignorGuid } = payload;
        
        const response: AxiosResponse<ResponseBase<UnitResponse[]>> = yield call(fetchUnitsAsync, assignorGuid);

        if (response?.data?.status == 1) {
        yield put(getUnitsSuccess(response?.data?.result));
        } else {
        yield put(getUnitsError(response?.data?.message));
        }
    } catch (error) {
        yield put(getUnitsError(error));
    }
}

export function* watchFetchDepartments() {
    yield takeEvery(DEPARTMENT_LIST, fetchDepartments);
}
  
const fetchDepartmentsAsync = async (assignorGuid: string) =>
    await api.get(`assignorOrganization/department/${assignorGuid}`)
        .then((response: any) => response)
        .catch((error: any) => error);


function* fetchDepartments({ payload }: fetchDepartmentParams) {
    try {
        const { assignorGuid } = payload;
        
        const response: AxiosResponse<ResponseBase<DepartmentResponse[]>> = yield call(fetchDepartmentsAsync, assignorGuid);

        if (response?.data?.status == 1) {
        yield put(getDepartmentsSuccess(response?.data?.result));
        } else {
        yield put(getDepartmentsError(response?.data?.message));
        }
    } catch (error) {
        yield put(getDepartmentsError(error));
    }
}

export default function* rootSaga() {
    yield all([
      fork(watchFetchCostCenters),
      fork(watchFetchUnits),
      fork(watchFetchDepartments),
    ]);
  }